import React, { useEffect, useState } from 'react'
import { Col, Row, Container, Card, Accordion } from 'react-bootstrap';
import { domain, getExplore, getExploreTerm, getImageData } from '../../assets/js/api';
import './assets/scss/styles.scss';
import { FaBook, FaBookOpen, FaCamera, FaFilePdf, FaMale, FaSearchPlus, FaTimes } from 'react-icons/fa';
import { getImage, pdfReader, translate } from '../../assets/js/functions';
import Modal from 'react-modal';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ExploreItem from './ExploreItem';

export default function Explore() {

    const [items, setItems]                             = useState([])
    const [termInfo, setTermInfo]                       = useState([])
    const [searchParams]                                = useSearchParams()
    const [currentImage, setCurrentImage]               = useState(null)
    const [openImage, setOpenImage]                     = useState(false)
    const [openFotografias, setOpenFotografias]         = useState(false)
    const [openHemeroteca, setOpenHemeroteca]           = useState(false)
    const [openDocumentos, setOpenDocumentos]           = useState(false)
    const [openTestimonios, setOpenTestimonios]         = useState(false)
    const [imageData, setImageData]                     = useState([])
    const [currentExploreItem, setCurrentExploreItem]   = useState(null)
    const navigate = useNavigate();
    const params = useParams();
    const openSection = searchParams.get('open') || null
    const id = params.id;

    useEffect(() => {
        getExplore(id).then(res => {
            setItems(res.data.result)
        })
        getExploreTerm(id).then(term => {
            setTermInfo(term.data.result[0])
            term.data.result[0].other_images && JSON.parse(term.data.result[0].other_images).map(
                image => {
                    getImageData(image).then(
                        (res) => { setImageData(imageData => [...imageData, res.data.result[0]]) }
                    )
                    return null
                }
            )
        })
        sectionOpen();
    }, []);

    function sectionOpen(){
        if(openSection)
        switch(openSection){
            case "fotografias":
                setOpenFotografias(true);
                break;
            case "hemeroteca":
                setOpenHemeroteca(true);
                break;
            case "documentos":
                setOpenDocumentos(true);
                break;
            case "testimonios":
                setOpenTestimonios(true);
                break;
            default:
                return null;
        }
        return null
    }

    function _exploreItem(val, isOpen){
        setCurrentExploreItem(isOpen ? null : val)
    }

    return (
        <>
            <div id="explore">
                { termInfo && <Breadcrumbs beforeData={[{name: translate("Mapa"), url: "/map"}]} currentSite={termInfo.term}/> }
                { termInfo && <Helmet><title>{termInfo.term}</title></Helmet> }
                <Container>
                    <Row className='header-item'>
                        <Col sm={2}>
                            <div className='header-img'>
                                {
                                    !!termInfo.identify_image &&
                                    <>
                                        <img src={getImage(JSON.parse(termInfo.identify_image)[0])} alt={getImage(JSON.parse(termInfo.identify_image)[0])}/>
                                    </>
                                }
                                <span onClick={() => {
                                    setOpenImage(!openImage)
                                    setCurrentImage(getImage(JSON.parse(termInfo.identify_image)[0]))
                                }}><FaSearchPlus/></span>
                            </div>
                        </Col>
                        <Col sm={10}>
                            <div className='header-title'>
                                <h1>{termInfo && termInfo.term}</h1>
                            </div>
                        </Col>
                    </Row>
                    <Row className='content'>
                        <Col sm={9} className='aside-left'>
                            <Accordion className='item-list'>
                                { !!items.length && items.map(
                                    (item, i) => <ExploreItem item={item} key={i} open={currentExploreItem === item.term_id} onClick={(val, isOpen) => _exploreItem(val, isOpen)}/>
                                ) }
                            </Accordion>
                        </Col>
                        <Col sm={3} className='aside-right'>
                            <div className='items'>
                                <Col sm={12}>
                                    <Card className='fotografias' onClick={() => {
                                            if (getQuantity("Fotografias") > 0){
                                                setOpenFotografias(true)
                                                navigate({search: "?open=fotografias"})
                                            }
                                        }}>
                                        <span className='qt'>{ getQuantity("Fotografias") }</span>
                                        <span className='title'>{ translate("Fotografías") }</span>
                                        <FaCamera/>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <Card className='hemeroteca' onClick={() => {
                                            if (getQuantity("Hemeroteca") > 0){
                                                setOpenHemeroteca(true)
                                                navigate({search: "?open=hemeroteca"})
                                            }
                                        }}>
                                        <span className='qt'>{ getQuantity("Hemeroteca") }</span>
                                        <span className='title'>{ translate("Hemeroteca") }</span>
                                        <FaBookOpen/>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <Card className='documentos' onClick={() => {
                                            if (getQuantity("Documentos") > 0){
                                                setOpenDocumentos(true)
                                                navigate({search: "?open=documentos"})
                                            }
                                        }}>
                                        <span className='qt'>{ getQuantity("Documentos") }</span>
                                        <span className='title'>{ translate("Documentos") }</span>
                                        <FaBook/>
                                    </Card>
                                </Col>
                                <Col sm={12}>
                                    <Card className='testimonios' onClick={() => {
                                            if (getQuantity("Testimonios") > 0){
                                                setOpenTestimonios(true)
                                                navigate({search: "?open=testimonios"})
                                            }
                                        }}>
                                        <span className='qt'>{ getQuantity("Testimonios") || 0 }</span>
                                        <span className='title'>{translate("Testimonios")}</span>
                                        <FaMale/>
                                    </Card>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            {
                termInfo ?
                <>
                    <Modal
                        isOpen={openFotografias}
                        onRequestClose={() => {
                            setOpenFotografias(false)
                        }}
                        contentLabel="Fotografias Modal"
                        ariaHideApp={false}
                    >
                        <Container>
                            <span className='clickable' onClick={() => {
                                setOpenFotografias(false)
                                navigate('', {replace: true})
                            }}><FaTimes/></span>
                            <h3>{termInfo && termInfo.term}</h3>
                            <h2>{translate("Fotografías")} <FaCamera/></h2>
                            { getDataModal("Fotografias") }
                        </Container>
                    </Modal>

                    <Modal
                        isOpen={openHemeroteca}
                        onRequestClose={() => {
                            setOpenHemeroteca(false)
                            navigate('', {replace: true})
                        }}
                        contentLabel="Hemeroteca Modal"
                        ariaHideApp={false}
                    >
                        <Container>
                            <span className='clickable' onClick={() => {
                                setOpenHemeroteca(false)
                                navigate('', {replace: true})
                            }}><FaTimes/></span>
                            <h3>{termInfo && termInfo.term}</h3>
                            <h2>{translate("Hemeroteca")} <FaBookOpen/></h2>
                            { getDataModal("Hemeroteca") }
                        </Container>
                    </Modal>

                    <Modal
                        isOpen={openDocumentos}
                        onRequestClose={() => {
                            setOpenDocumentos(false)
                            navigate('', {replace: true})
                        }}
                        contentLabel="Documentos Modal"
                        ariaHideApp={false}
                    >
                        <Container>
                            <span className='clickable' onClick={() => {
                                setOpenDocumentos(false)
                                navigate('', {replace: true})
                            }}><FaTimes/></span>
                            <h3>{termInfo && termInfo.term}</h3>
                            <h2>{translate("Documentos")} <FaBook/></h2>
                            { getDataModal("Documentos") }
                        </Container>
                    </Modal>

                    <Modal
                        isOpen={openTestimonios}
                        onRequestClose={() => {
                            setOpenTestimonios(false)
                            navigate('', {replace: true})
                        }}
                        contentLabel="Testimonios Modal"
                        ariaHideApp={false}
                    >
                        {termInfo &&
                            <Container>
                                <span className='clickable' onClick={() => {
                                    setOpenTestimonios(false)
                                    navigate('', {replace: true})
                                }}><FaTimes/></span>
                                <h3>{termInfo.term}</h3>
                                <h2>{translate("Testimonios")} <FaMale/></h2>
                                <Row>
                                    {
                                        termInfo.pdf_resolved &&
                                        JSON.parse(termInfo.pdf_resolved).map(
                                            (pdf, index) => {
                                                return  <Col key={index} sm={4} onClick={() => pdfReader(pdf)} className='pdf-documents'>
                                                            <FaFilePdf/>
                                                            <h3>{JSON.parse(termInfo.pdf_title)[index]}</h3>
                                                        </Col>
                                            }
                                        )
                                    }
                                </Row>
                            </Container>
                        }
                    </Modal>

                    <Modal
                        isOpen={openImage}
                        onRequestClose={() => setOpenImage(false)}
                        contentLabel="Image Modal"
                        className={"image-modal"}
                        ariaHideApp={false}
                    >
                        <Container>
                            <span className='clickable' onClick={() => setOpenImage(false)}><FaTimes/></span>
                            { currentImage &&
                                <>
                                    <img src={currentImage.image ? domain+currentImage.image : currentImage} alt={currentImage.image ? domain+currentImage.image : currentImage} />
                                    <span className='footprint'>{ currentImage.footprint ? currentImage.footprint : termInfo.title }</span>
                                </>
                            }
                        </Container>
                    </Modal>
                </>
                : null
            }

        </>
    )

    function getDataModal(type){
        return <Row>
            {
                imageData ? imageData.map(
                    data => {
                        if (data.code === type){
                            return <Col key={data.section_id} sm={4} className='images' onClick={() => {
                                        setOpenImage(!openImage)
                                        setCurrentImage(data)
                                    }}>
                                        <img className='image' src={domain+data.image}/>
                                        <span className='caption'>{data.footprint}</span>
                                    </Col>
                        }
                    }
                ) : translate("No hay ningún resultado.")
            }
        </Row>
    }

    function getQuantity(type){
        let arr = 0;

        if (type === "Testimonios") return termInfo.pdf_resolved && !!JSON.parse(termInfo.pdf_resolved).length && JSON.parse(termInfo.pdf_resolved).length

        imageData && imageData.map(
            data => {
                if (data.code === type){
                    arr++;
                }
                return null
            }
        )

        return arr;
    }

}